import React, { useEffect, useMemo, useState } from "react";
import {
  CircularProgress,
  Grid,
  Box,
  Card,
  Typography,
  CardContent,
  Divider,
  List,
  ListItemIcon,
  ListItemText,
  ListItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  useMediaQuery,
  Avatar,
  CardHeader,
  Tooltip,
} from "@mui/material";
import {
  useGetAllDhashboardFristQuery,
  useGetPositionQuery,
  useGetMissingPunchOutQuery,
  useGetTeamQuery,
  useGetPunchDashboardQuery,
  useGetOutOfLocationQuery,
} from "../../Api/attoDeskApi";
import {
  IPosition,
  ITeam,
  IPunchEmpRecord,
  historyPuncRecord
} from "../../Api/Interface/api.interface";
import useDebounce from "../../Components/SearchDebonce/useDebounce";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../theme/appStyles";
import Pagination from "../../Components/Pagination";
import dayjs, { Dayjs } from "dayjs";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import InventoryIcon from "@mui/icons-material/Inventory";
import ShieldIcon from "@mui/icons-material/Shield";
import GroupIcon from "@mui/icons-material/Group";
import EventIcon from "@mui/icons-material/EventNote";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import { Link } from "react-router-dom";
import Badge from "@mui/material/Badge";
import { CiEdit } from "react-icons/ci";
import UpdateOutlinedIcon from "@mui/icons-material/UpdateOutlined";
import { GiReceiveMoney } from "react-icons/gi";
import { FaUserClock } from "react-icons/fa";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import PayrollTrendChart from "./Component/payroll";
import LocationOnIcon from '@mui/icons-material/LocationOn';

const capitalizeFirstLetter = (name: string | null | undefined) => {
  if (!name) return "";
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

const lightThemeColor = JSON.parse(
  localStorage.getItem("lightThemeColor") || "{}"
);
const setCardBRadius = lightThemeColor?.cardBorderRadius || "none";

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(1000);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [paymentMonthYear, setPaymentMonthYear] = useState<Dayjs>(dayjs());
  const [selectedCilent, setSelectedClient] = useState<string | "">("");
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const { data, isLoading, isError, refetch } = useGetMissingPunchOutQuery();

  const { data: tenantData, isLoading: tenantIsLoading } = useGetTeamQuery({
    searchText: "",
    id: "",
  });

  const { data: positionData, isLoading: positionLoading } =
    useGetPositionQuery({
      searchText: "",
    });

  const { data: dashboardData, isLoading: dashboardIsLoading } =
    useGetPunchDashboardQuery();

    const {
      data: outOfLocationData,
      isLoading: outOfLocationIsLoadig,
      isError: outOfLocationIsError,
      refetch: outOfLocationRefetch,
    } = useGetOutOfLocationQuery({
      date: dayjs().format("YYYY-MM-DD"),
    });

  const teamList = useMemo(() => {
    return tenantData?.data as ITeam[];
  }, [tenantData?.data]);

  const positionList = useMemo(() => {
    return positionData?.data as IPosition[];
  }, [positionData?.data]);

  const postionMap = useMemo(() => {
    const map = new Map();
    positionList?.forEach((category) => {
      map.set(category.id, category.positionName);
    });
    return map;
  }, [positionList]);

  const outOfLocationRecords: historyPuncRecord[] = Array.isArray(
    outOfLocationData?.data
  )
    ? (outOfLocationData?.data as historyPuncRecord[])
    : [];

  const teamMap = useMemo(() => {
    const map = new Map<
      number,
      {
        name: string;
        image: string;
        hourlySalary: string;
        otHourlySalary: string;
        positionName: string | null;
      }
    >();

    teamList?.forEach((teamMember) => {
      const fullName = `${capitalizeFirstLetter(
        teamMember.teamFirstName || ""
      )} ${capitalizeFirstLetter(teamMember.teamLastName || "")}`.trim();
      const positionName = postionMap.get(teamMember.teamPositionId) || null;

      map.set(teamMember.id, {
        name: fullName,
        image: teamMember.teamImg,
        hourlySalary: teamMember.teamHourlySalary,
        otHourlySalary: teamMember.teamOtHourlySalary,
        positionName,
      });
    });

    return map;
  }, [teamList, postionMap]);

  const coursings: IPunchEmpRecord[] = Array.isArray(data?.data)
    ? (data?.data as IPunchEmpRecord[])
    : [];

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const { data: clientData, isLoading: clientIsLoading } =
    useGetAllDhashboardFristQuery({
      id: "",
    });

  if (
    isLoading ||
    tenantIsLoading ||
    positionLoading ||
    clientIsLoading ||
    dashboardIsLoading
  ) {
    return (
      <Box p={isMobile ? 2 : 1}>
        <Grid container spacing={2}>
          {[...Array(3)].map((_, index) => (
            <Grid
              item
              md={12}
              sm={12}
              xs={12}
              lg={4}
              key={`top-skeleton-${index}`}
            >
              <Skeleton
                variant="rectangular"
                // height={200}
                height={isMobile ? 200 : 200}
                animation="wave"
                sx={{
                  borderRadius: setCardBRadius,
                  backgroundColor: "#d0ddd0",
                }}
              />
            </Grid>
          ))}

          {[...Array(2)].map((_, index) => (
            <Grid item xs={12} lg={12} key={`bottom-skeleton-${index}`}>
              <Skeleton
                variant="rectangular"
                height={400}
                animation="wave"
                sx={{
                  borderRadius: setCardBRadius,
                  backgroundColor: "#d0ddd0",
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  }

  return (
    <div>
      <Grid container>
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          sx={{
            // backgroundColor: "#d0ddd0",
            // background: `linear-gradient(to bottom, ${theme.palette.primary.main}, #fff)`,
            // background: `linear-gradient(to bottom,  ${theme.palette.cardAdd.thirdBgColor},${theme.palette.cardAdd.thirdBgColor},${theme.palette.cardAdd.thirdBgColor},${theme.palette.primary.main},  #fff)`,

            padding: isMobile ? 1 : 2,
            minHeight: "100vh",
            borderRadius: 3,
            // boxShadow: 3,
          }}
        >
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item lg={4} xs={12}>
                  <Link
                    to={`/schedule/list`}
                    className={classes.iconLinkPropNormal}
                  >
                    <Card
                      sx={{
                        height: "100%",
                        background: theme.palette.cardAdd.bgColor,
                        boxShadow: "none",
                        color: "#0d47a1",
                        borderRadius: setCardBRadius,
                        // boxShadow: 3,
                        border: "1px solid #90caf9",
                        cursor: "pointer",
                      }}
                      onClick={() => navigate(`/schedule/list`)}
                    >
                      <CardContent>
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          mb={2}
                        >
                          <Box display="flex" alignItems="center">
                            <Box
                              sx={{
                                background: "#bbdefb",
                                borderRadius: "50%",
                                width: 60,
                                height: 60,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                mr: 2,
                              }}
                            >
                              <FaUserClock
                                style={{ color: "#0d47a1", fontSize: 30 }}
                              />
                            </Box>
                            <Typography variant="h5" sx={{ color: "#0d47a1" }}>
                              Active Clock In/Out Records
                            </Typography>
                          </Box>
                          <Typography variant="h2" fontWeight={600}>
                            {clientData?.data.total_punches ?? "-"}
                          </Typography>
                        </Box>
                        <Divider sx={{ my: 2, borderColor: "#64b5f6" }} />
                        <Box display="flex" justifyContent="space-between">
                          <Typography>Clock In</Typography>
                          <Typography fontWeight="bold">
                            {clientData?.data.total_punch_in ?? "-"}
                          </Typography>
                        </Box>
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          mt={1}
                        >
                          <Typography>Clock Out</Typography>
                          <Typography fontWeight="bold">
                            {clientData?.data.total_punch_out ?? "-"}
                          </Typography>
                        </Box>
                      </CardContent>
                    </Card>
                  </Link>
                </Grid>

                <Grid item lg={4} xs={12}>
                  <Link
                    to={`/payroll/list`}
                    className={classes.iconLinkPropNormal}
                  >
                    <Card
                      sx={{
                        height: "100%",
                        background: theme.palette.cardAdd.bgColor,
                        boxShadow: "none",
                        color: "#1b5e20",
                        borderRadius: setCardBRadius,
                        // boxShadow: 3,
                        border: "1px solid #a5d6a7",
                      }}
                    >
                      <CardContent>
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          mb={2}
                        >
                          <Box display="flex" alignItems="center">
                            <Box
                              sx={{
                                background: "#c8e6c9",
                                borderRadius: "50%",
                                width: 60,
                                height: 60,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                mr: 2,
                              }}
                            >
                              <GiReceiveMoney
                                style={{ color: "#1b5e20", fontSize: 40 }}
                              />
                            </Box>
                            <Typography variant="h5" sx={{ color: "#1b5e20" }}>
                              Total Payroll
                            </Typography>
                          </Box>
                          <Typography variant="h2" fontWeight={600}>
                            {clientData?.data.total_payroll_record ?? "-"}
                          </Typography>
                        </Box>
                        <Divider sx={{ my: 2, borderColor: "#81c784" }} />
                        <Box display="flex" justifyContent="space-between">
                          <Typography>Gross Salary</Typography>
                          <Typography fontWeight="bold">
                            {clientData?.data.total_salary != null
                              ? `$ ${Number(
                                  clientData.data.total_salary
                                ).toFixed(2)}`
                              : "-"}
                          </Typography>
                        </Box>
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          mt={1}
                        >
                          <Typography>Hours</Typography>
                          <Typography fontWeight="bold">
                            {clientData?.data.total_hours
                              ? `${clientData.data.total_hours} hrs`
                              : "-"}
                          </Typography>
                        </Box>
                      </CardContent>
                    </Card>
                  </Link>
                </Grid>

                <Grid item lg={4} xs={12}>
                  <Link
                    to={`/team/list`}
                    className={classes.iconLinkPropNormal}
                  >
                    <Card
                      sx={{
                        height: "100%",
                        background: theme.palette.cardAdd.bgColor,
                        boxShadow: "none",
                        color: "#263238",
                        borderRadius: setCardBRadius,
                        // boxShadow: 3,
                        border: "1px solid #cfd8dc",
                      }}
                    >
                      <CardContent>
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          mb={2}
                        >
                          <Box display="flex" alignItems="center">
                            <Box
                              sx={{
                                background: "#cfd8dc",
                                borderRadius: "50%",
                                width: 60,
                                height: 60,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                mr: 2,
                              }}
                            >
                              <GroupIcon
                                sx={{ color: "#263238", fontSize: 32 }}
                              />
                            </Box>
                            <Typography variant="h5" sx={{ color: "#263238" }}>
                              Total Staff
                            </Typography>
                          </Box>
                          <Typography variant="h2" fontWeight={600}>
                            {clientData?.data.employee_count ?? "-"}
                          </Typography>
                        </Box>
                        <Divider sx={{ my: 2, borderColor: "#b0bec5" }} />
                        <Box display="flex" justifyContent="space-between">
                          <Typography>Active Staff (Today)</Typography>
                          <Typography fontWeight="bold">
                            {clientData?.data.active_employees ?? "-"}
                          </Typography>
                        </Box>
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          mt={1}
                        >
                          <Typography>Todo (Today)</Typography>
                          <Typography fontWeight="bold">
                            {clientData?.data.totalTodayToDoStaff ?? "-"}
                          </Typography>
                        </Box>
                      </CardContent>
                    </Card>
                  </Link>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={2}>
                {dashboardData?.data.invalidPunchRecords &&
                  dashboardData?.data.invalidPunchRecords?.length > 0 && (
                    <Grid
                      item
                      lg={coursings && coursings.length > 0 ? 5 : 12}
                      md={12}
                      sm={12}
                      xs={12}
                    >
                      <Card
                        sx={{
                          height: "100%",
                          background: theme.palette.cardAdd.bgColor,
                          boxShadow: "none",
                          // color: theme.palette.error.main,
                          borderRadius: setCardBRadius,
                          border: `1px solid ${theme.palette.error.main}`,
                        }}
                      >
                        <CardContent>
                          {/* Heading */}
                          <Box display="flex" alignItems="center" mb={2}>
                            <Box
                              sx={{
                                background: "#fdecea",
                                borderRadius: "50%",
                                width: 50,
                                height: 50,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                mr: 2,
                              }}
                            >
                              <ErrorOutlineIcon sx={{ color: "#d32f2f" }} />
                            </Box>
                            <Typography
                              className={classes.mL2Heading}
                              sx={{ color: theme.palette.error.main }}
                            >
                              Please check punch in/out times — invalid record.
                            </Typography>
                          </Box>

                          {/* List of Invalid Records */}
                          <Box sx={{ mt: 5 }}>
                            {dashboardData.data.invalidPunchRecords.map(
                              (record, index) => (
                                <Grid
                                  key={record.id}
                                  container
                                  spacing={1}
                                  alignItems="center"
                                  sx={{
                                    py: 2,
                                    borderBottom: "1px solid #eee",
                                    cursor: "pointer",
                                    "&:hover": {
                                      backgroundColor: "#f7f7f7",
                                    },
                                  }}
                                  onClick={() =>
                                    navigate(
                                      `/schedule/list?date=${dayjs(
                                        record.punch_in_date
                                      ).format("YYYY-MM-DD")}`
                                    )
                                  }
                                >
                                  <Grid item xs={12} sm={5}>
                                    <Typography
                                      variant="body2"
                                      sx={{ fontWeight: 600 }}
                                    >
                                      • {teamMap.get(record.empid)?.name || ""}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12} sm={7}>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        fontSize: "0.875rem",
                                        color: "#444",
                                      }}
                                    >
                                      Punch In:{" "}
                                      <strong>
                                        {dayjs(record.punch_in_date).format(
                                          "MMM DD"
                                        )}{" "}
                                        {formatTime(record.punch_in_time)}
                                      </strong>{" "}
                                      | Out:{" "}
                                      <strong>
                                        {dayjs(record.punch_out_date).format(
                                          "MMM DD"
                                        )}{" "}
                                        {formatTime(record.punch_out_time)}
                                      </strong>
                                    </Typography>
                                  </Grid>
                                </Grid>
                              )
                            )}
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  )}
                {coursings.length > 0 && (
                  <Grid
                    item
                    lg={
                      dashboardData?.data.invalidPunchRecords &&
                      dashboardData.data.invalidPunchRecords.length > 0
                        ? 7
                        : 12
                    }
                    md={12}
                    sm={12}
                    xs={12}
                  >
                    <Card
                      sx={{
                        height: "100%",
                        background: theme.palette.cardAdd.bgColor,
                        boxShadow: "none",
                        color: theme.palette.error.main,
                        borderRadius: setCardBRadius,
                        // boxShadow: 2,
                        border: `1px solid ${theme.palette.error.main}`,
                      }}
                    >
                      <CardContent>
                        <Box display="flex" alignItems="center" mb={2}>
                          <Box
                            sx={{
                              background: "#fdecea",
                              borderRadius: "50%",
                              width: 50,
                              height: 50,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              mr: 2,
                            }}
                          >
                            <UpdateOutlinedIcon sx={{ color: "#d32f2f" }} />{" "}
                            {/* Grey icon */}
                          </Box>
                          <Typography className={classes.mL2Heading}>
                            Incomplete Punch Details
                          </Typography>
                        </Box>

                        <Grid container>
                          <TableContainer>
                            <Table className={classes.table}>
                              <TableHead className={classes.tableHeaderRow}>
                                <TableRow>
                                  <TableCell className={classes.tablheader2}>
                                    <strong>Name</strong>
                                  </TableCell>
                                  <TableCell
                                    className={classes.tablheader2}
                                    // sx={{  color: "#424242",}}
                                  >
                                    <strong>Date</strong>
                                  </TableCell>
                                  <TableCell
                                    className={classes.tablheader2}
                                    // sx={{  color: "#424242", }}
                                  >
                                    <strong>Punch In</strong>
                                  </TableCell>
                                  <TableCell
                                    className={classes.tablheader2}
                                    // sx={{ color: "#424242", }}
                                  >
                                    <strong>Punch Out</strong>
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {isError || coursings.length === 0 ? (
                                  <TableRow>
                                    <TableCell colSpan={20} align="center">
                                      {isError
                                        ? "Error fetching data"
                                        : "No data available"}
                                    </TableCell>
                                  </TableRow>
                                ) : (
                                  coursings
                                    .slice(
                                      page * rowsPerPage,
                                      page * rowsPerPage + rowsPerPage
                                    )
                                    .map((row: IPunchEmpRecord, index) => (
                                      <TableRow
                                        key={row.id}
                                        className={classes.tableRowHover}
                                      >
                                        <TableCell
                                          scope="row"
                                          className={classes.tablCell}
                                        >
                                          <Link
                                            to={`/team-history/${row.empid}`}
                                            className={
                                              classes.iconLinkPropNormal
                                            }
                                          >
                                            <Typography
                                              sx={{
                                                // color: "#1976d2", // Link color
                                                cursor: "pointer",
                                                display: "inline-flex",
                                                gap: 1,
                                              }}
                                              // onClick={() =>
                                              //   navigate(
                                              //     `/customer/${policy.policyCustomerId}/policy/${policy.policyNumber}`
                                              //   )
                                              // }
                                            >
                                              {teamMap.get(row.empid)?.name ||
                                                ""}
                                              {/* <FontAwesomeIcon icon={faUser} /> */}
                                            </Typography>
                                          </Link>
                                        </TableCell>
                                        <TableCell
                                          scope="row"
                                          className={classes.tablCell}
                                          // sx={{ textAlign: "center" }}
                                        >
                                          <Typography
                                            sx={{
                                              // /  color: "#1976d2",
                                              cursor: "pointer",
                                              display: "inline-flex",
                                              // alignItems: "center",
                                              gap: 1,
                                            }}
                                          >
                                            {dayjs(row.punch_in_date).isValid()
                                              ? dayjs(row.punch_in_date).format(
                                                  "YYYY-MM-DD"
                                                )
                                              : " "}
                                          </Typography>
                                        </TableCell>
                                        <TableCell
                                          scope="row"
                                          className={classes.tablCell}
                                          // sx={{ textAlign: "center" }}
                                        >
                                          <Grid
                                            container
                                            spacing={1}
                                            // justifyContent={"center"}
                                          >
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                              sx={
                                                {
                                                  // display: "flex",
                                                  // justifyContent: "center",
                                                }
                                              }
                                            >
                                              <Box
                                                className={
                                                  classes.editButtonStatusAvailable
                                                }
                                              >
                                                {formatTime(
                                                  row.punch_in_time
                                                ) || "Pending"}
                                              </Box>
                                            </Grid>
                                          </Grid>
                                        </TableCell>
                                        <TableCell
                                          scope="row"
                                          className={classes.tablCell}
                                          // sx={{ textAlign: "center" }}
                                        >
                                          <Grid
                                            container
                                            spacing={1}
                                            // justifyContent={"center"}
                                          >
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                              // sx={{
                                              //   display: "flex",
                                              //   justifyContent: "center",
                                              // }}
                                            >
                                              <Tooltip
                                                title={
                                                  <>
                                                    <Typography
                                                      variant="body2"
                                                      key={index}
                                                    >
                                                      <strong>Edit </strong>
                                                    </Typography>
                                                    <Typography
                                                      variant="body2"
                                                      key={index}
                                                    >
                                                      <strong>
                                                        Punch-out Time
                                                      </strong>
                                                    </Typography>
                                                  </>
                                                }
                                                sx={{ fontSize: "14px" }}
                                              >
                                                <Box
                                                  className={
                                                    classes.editButtonStatusWaiting
                                                  }
                                                  sx={{
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() =>
                                                    navigate(
                                                      `/schedule/list?date=${dayjs(
                                                        row.punch_in_date
                                                      ).format("YYYY-MM-DD")}`
                                                    )
                                                  }
                                                >
                                                  {formatTime(
                                                    row.punch_out_time
                                                  ) || "Pending"}
                                                  <CiEdit
                                                    style={{
                                                      fontSize: 20,
                                                      marginLeft: "5px",
                                                    }}
                                                  />
                                                </Box>
                                              </Tooltip>
                                            </Grid>
                                          </Grid>
                                        </TableCell>
                                      </TableRow>
                                    ))
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                )}
              </Grid>
            </Grid>
          
                {outOfLocationRecords &&
                  outOfLocationRecords?.length > 0 && (
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                    >
                      <Card
                        sx={{
                          height: "100%",
                          background: theme.palette.cardAdd.bgColor,
                          boxShadow: "none",
                          // color: theme.palette.error.main,
                          borderRadius: setCardBRadius,
                          border: `1px solid #e3791a`,
                        }}
                      >
                        <CardContent>
                          {/* Heading */}
                          <Box display="flex" alignItems="center" mb={2}>
                            <Box
                              sx={{
                                background: "#fff1cd",
                                borderRadius: "50%",
                                width: 50,
                                height: 50,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                mr: 2,
                              }}
                            >
                              <LocationOnIcon sx={{ color: "#e3791a" }} />
                            </Box>
                            <Typography
                              className={classes.mL2Heading}
                              sx={{ color: "#e3791a" }}
                            >
                             Please review today’s out-of-location punch in/out.
                            </Typography>
                          </Box>

                          {/* List of Invalid Records */}
                          <Box sx={{ mt: 5 }}>
                            {outOfLocationRecords.map(
                              (record, index) => (
                                <Grid
                                  key={record.id}
                                  container
                                  spacing={1}
                                  alignItems="center"
                                  sx={{
                                    py: 2,
                                    borderBottom: "1px solid #eee",
                                    cursor: "pointer",
                                    "&:hover": {
                                      backgroundColor: "#f7f7f7",
                                    },
                                  }}
                                  onClick={() =>
                                    navigate(
                                      `/schedule/list?date=${dayjs(
                                        record.date
                                      ).format("YYYY-MM-DD")}`
                                    )
                                  }
                                >
                                  <Grid item xs={12} sm={5}>
                                    <Typography
                                      variant="body2"
                                      sx={{ fontWeight: 600 }}
                                    >
                                      • {teamMap.get(record.empid)?.name || ""}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12} sm={7}>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        fontSize: "0.875rem",
                                        color: "#444",
                                      }}
                                    >
                                      <strong>
                                    <span
                                            style={{
                                              color: "#e3791a",
                                              fontWeight: 600,
                                            }}
                                          >
                                    {`${record.status} | `}{" "}
                                    </span>
                                    </strong>
                                    {`${dayjs(record.date).format("MMM DD, YYYY")} | `} 
                                      {` ${formatTime(record.time)}`}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              )
                            )}
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  )}
             
            {/* <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card
                    sx={{
                      height: "100%",
                      background: theme.palette.cardAdd.bgColor,
                      boxShadow: "none",
                      // color: theme.palette.error.main,
                      borderRadius: setCardBRadius,
                      border: `1px solid #004262`,
                    }}
                  >
                    <CardContent>
                      <PayrollTrendChart />
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Grid> */}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default Index;
